import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionBlacklist } from './competition-blacklist'
import { competitionBlacklistActions } from './competition-blacklist.actions'
import * as fromCompetitionBlacklist from './competition-blacklist.reducer'
import { CompetitionBlacklistService } from './competition-blacklist.service'

@Injectable()
export class CompetitionBlacklistEffects extends ResourceEffects<CompetitionBlacklist> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionBlacklistService: CompetitionBlacklistService
  ) {
    super(
      fromCompetitionBlacklist.FEATURE_NAME,
      competitionBlacklistService,
      competitionBlacklistActions,
      actions$
    )
  }
}
